import { useState } from 'react';
import * as St from './WegetPalletList.styled';

export function WegetPalletList({
    palletDatas,
    selectedPalletData,
    onSelectPalletData
}) {
    return (
        <>
            <St.BoxContainer.RootContainer>
                {palletDatas?.map(palletData => {
                    return (
                        <>
                            {palletData?.devidedSubItems?.map(subItem => {
                                return (
                                    <St.BoxContainer.ItemBox>
                                        <div className='firstFlex'>
                                            <div className='palletNumber'>
                                                {palletData?.palletNumber}
                                            </div>
                                            <div className='itemName'>
                                                <div>{subItem?.productName}</div>
                                                <div>{subItem?.optionName1} / {subItem?.optionName2}</div>
                                            </div>
                                            <div className='boxQunatity'>
                                                {subItem?.boxQuantity} BOX
                                            </div>
                                        </div>
                                    </St.BoxContainer.ItemBox>
                                );
                            })}
                        </>
                    );
                })}

            </St.BoxContainer.RootContainer>
        </>
    );
}